module.exports = __webpack_public_path__ + "static/media/env1@2x.f964b95a.png";